export default "__VITE_ASSET__DndWqt8S__"